import { createAction } from '@reduxjs/toolkit';

import { errorPayloadCreator, getPayloadCreator } from 'app-components/flux/core/actionHelpers';

import type { QcsSyncResourcesPayload } from '../core/resourceStoreTypes';
import type { TaxLineItemProps } from './taxLineItemsTypes';

export const getTaxLineItems = createAction('GET_TAX_LINE_ITEMS', getPayloadCreator());
export const getTaxLineItemsSuccess = createAction(
  'GET_TAX_LINE_ITEMS_SUCCESS',
  getPayloadCreator<QcsSyncResourcesPayload<TaxLineItemProps>>(),
);
export const getTaxLineItemsFailure = createAction('GET_TAX_LINE_ITEMS_FAILURE', errorPayloadCreator);
